/**
 * Clipboard npm i clipboard -S
 * ElementUI npm i element-ui -S
 * */
import Clipboard from 'clipboard'
import ElementUI from 'element-ui'

let commons = {};

/**
 * 复制
 * data复制的数据，
 * obj按钮id
 * */
commons.copy = function copeLink(data, obj) {
  let copy = data;
  let clipboard = new Clipboard(obj, {
    text: function () {
      return copy;
    }
  });
  clipboard.on('success', function (e) {
    ElementUI.Message.closeAll();
    ElementUI.Message({
      message: '复制成功',
      type: 'success',
      duration: 900,
      offset: 300
    });
  });
};

/**
 * 提示弹窗
 * tip提示内容
 * */
commons.popup = function popups(tip) {
  ElementUI.MessageBox(tip, '提示', {
    confirmButtonText: '确定',
    callback: action => {
    }
  })
};

/**
 * 日期格式化
 * fmt格式如：yyyy-MM-dd
 * date日期
 * */
commons.formatTime = function dateFtt(fmt, date) {
  var o = {
    "M+": date.getMonth() + 1,
    "d+": date.getDate(),
    "h+": date.getHours(),
    "m+": date.getMinutes(),
    "s+": date.getSeconds(),
    "q+": Math.floor((date.getMonth() + 3) / 3), //季度
    "S": date.getMilliseconds()             //毫秒
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
  return fmt;
};


export default commons



// WEBPACK FOOTER //
// ./src/utils/common.js